import type { FaqItem } from '@nucleus-commerce/api-client/admin';

import { faqQuestionKey } from '@/features/dictionary';

/** The product type's suggested questions the product doesn't ask yet. */
export function pendingFaqSuggestions(
  faq: ReadonlyArray<{ question: string }>,
  productType: { suggestedFaq: readonly FaqItem[] } | null,
): readonly FaqItem[] {
  const asked = new Set(faq.map((item) => faqQuestionKey(item.question)));
  return (productType?.suggestedFaq ?? []).filter(
    (item) => !asked.has(faqQuestionKey(item.question)),
  );
}
